var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form-item',{attrs:{"label":_vm.i18nt('designer.setting.defaultValue')}},[_c('el-input',{attrs:{"type":"text"},on:{"change":_vm.emitDefaultValueChange},model:{value:(_vm.optionModel.defaultValue),callback:function ($$v) {_vm.$set(_vm.optionModel, "defaultValue", $$v)},expression:"optionModel.defaultValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }